import request from '@/utils/request';

export const fetchAdminOperationLogs = (params) => request.get('/admin/operation-log', { params });
export const fetchAdminOperationLogStats = (params) => request.get('/admin/operation-log/stats', { params });
